/* eslint-disable prefer-const */
import { PayloadAction } from '@reduxjs/toolkit';
import { closeAppBackdrop, getAppNavigate, notify, showAppBackdrop } from 'features/app/store/slice';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { IFilterUserManagement, IPermissionData, IUserData, IUserManagementData } from 'types/models/user-management';
import { formatPath, getQueryString } from 'utils';
import { apiDelete, apiGet, apiPost } from 'utils/api';
import UserManagementPaths from '../models/paths';
import { createNewUser, deleteAllHistory, deleteUser, editUser, editUserConfigure, editUserLLM, fetchDataDepartment, fetchDataDepartmentSuccess, fetchDataUser, fetchDataUserSuccess, getFilterUserManagement, updateInfoMultiUser, updateStatusUser } from './slice';
import { IApiResponse } from 'types/api';
import HistoryManagementPaths from 'features/history-chat/models/paths';

export const apiDeleteUser = (data: Partial<any>) => {
  return apiDelete<IPermissionData>(formatPath(UserManagementPaths.delete_user),
    {
      id: data.user_id,
      reason: data.reason
    }
  );
};

function* handleDeleteUser(action: PayloadAction<any>) {
  yield put(showAppBackdrop());
  try {
    const response: IApiResponse<any> = yield call(apiDeleteUser, action.payload);
    if (response.data) {
      yield put(
        notify(response.data.detail, { options: { variant: 'success' } })
      );
      yield call(handleFetchUsers);
      yield put(closeAppBackdrop());
    } else {
      if (response.detail !== '') {
        yield put(
          notify(`${response.detail}`, {
            options: { variant: 'error' },
          })
        );
      }
      yield put(closeAppBackdrop());
    }
  } catch (e) {
    yield put(closeAppBackdrop());
  }
}

export const apiFetchUsers = (query: Partial<IFilterUserManagement>) => {
  const queryString = getQueryString({ ...query });
  return apiGet<IPermissionData>(formatPath(UserManagementPaths.get_list_user, queryString));
};

export function* handleFetchUsers() {
  yield put(showAppBackdrop());
  try {
    const pathName: string = yield select(getAppNavigate);

    let filterData: IFilterUserManagement = yield select(getFilterUserManagement);

    if (pathName === '/user-management') {
      filterData = {
        ...filterData,
        current_page: 'user'
      }
    }
    if (pathName === '/config-rule') {
      filterData = {
        ...filterData,
        current_page: 'config'
      }
    }

    const response: IApiResponse<any> = yield call(apiFetchUsers, filterData);
    if (response.data) {
      yield put(fetchDataUserSuccess(response.data));
      yield put(closeAppBackdrop());
    } else {
      if (response.detail !== '') {
        yield put(
          notify(`${response.detail}`, {
            options: { variant: 'error' },
          })
        );
      }
      yield put(closeAppBackdrop());
    }
  } catch (e) {
    yield put(closeAppBackdrop());
  }
}

export const apiFetchDataDepartments = () => {
  return apiGet<any>(UserManagementPaths.get_departments);
};

function* handleFetchDataDepartment() {
  try {
    const response: IApiResponse<any> = yield call(apiFetchDataDepartments);
    if (response.data) {
      yield put(fetchDataDepartmentSuccess(response.data));
    } else {
      yield put(
        notify(`${response.detail}`, {
          options: { variant: 'error' },
        })
      );
    }
  } catch (e: any) {
    //
  }
}

export const apiEditUser = (user_info: IUserManagementData) => {
  return apiPost<any>(formatPath(UserManagementPaths.update_user), user_info);
};

function* handleUpdateInfoUser(action: PayloadAction<IUserManagementData>) {
  yield put(showAppBackdrop());
  try {
    const response: IApiResponse<any> = yield call(apiEditUser, action.payload);
    if (response.data) {
      yield put(
        notify(response.data.detail, { options: { variant: 'success' } })
      );
      yield call(handleFetchUsers);
      yield put(closeAppBackdrop());
    } else {
      if (response.detail !== '') {
        yield put(
          notify(`${response.detail}`, {
            options: { variant: 'error' },
          })
        );
      }
      yield put(closeAppBackdrop());
    }
  } catch (e) {
    yield put(closeAppBackdrop());
  }
}

export const apiUpdateStatusUser = (user_list: any) => {
  return apiPost<any>(formatPath(UserManagementPaths.update_status_user), user_list);
};

function* handleUpdateStatusUser(action: PayloadAction<any>) {
  yield put(showAppBackdrop());
  try {
    const response: IApiResponse<any> = yield call(apiUpdateStatusUser, action.payload);
    if (response.data) {
      yield put(
        notify(response.data.detail, { options: { variant: 'success' } })
      );
      yield call(handleFetchUsers);
      yield put(closeAppBackdrop());
    } else {
      if (response.detail !== '') {
        yield put(
          notify(`${response.detail}`, {
            options: { variant: 'error' },
          })
        );
      }
      yield put(closeAppBackdrop());
    }
  } catch (e) {
    yield put(closeAppBackdrop());
  }
}

export const apiEditUserLLM = (data: any) => {
  return apiPost<any>(formatPath(UserManagementPaths.update_user_llm), data);
};

function* handleUpdateUserLLM(action: PayloadAction<any>) {
  yield put(showAppBackdrop());
  try {
    const response: IApiResponse<any> = yield call(apiEditUserLLM, action.payload);
    if (response.data) {
      yield put(
        notify(response.data.detail, { options: { variant: 'success' } })
      );
      yield call(handleFetchUsers);
      yield put(closeAppBackdrop());
    } else {
      if (response.detail !== '') {
        yield put(
          notify(`${response.detail}`, {
            options: { variant: 'error' },
          })
        );
      }
      yield put(closeAppBackdrop());
    }
  } catch (e) {
    yield put(closeAppBackdrop());
  }
}

export const apiEditUserConfigure = (data: any) => {
  return apiPost<any>(formatPath(UserManagementPaths.update_user_configure), data);
};

function* handleUpdateUserConfigure(action: PayloadAction<any>) {
  yield put(showAppBackdrop());
  try {
    const response: IApiResponse<any> = yield call(apiEditUserConfigure, action.payload);
    if (response.data) {
      yield put(
        notify(response.data.detail, { options: { variant: 'success' } })
      );
      yield call(handleFetchUsers);
      yield put(closeAppBackdrop());
    } else {
      if (response.detail !== '') {
        yield put(
          notify(`${response.detail}`, {
            options: { variant: 'error' },
          })
        );
      }
      yield put(closeAppBackdrop());
    }
  } catch (e) {
    yield put(closeAppBackdrop());
  }
}

export const apiCreateNewUser = async (user_info: IUserManagementData) => {
  return apiPost<any>(formatPath(UserManagementPaths.create_new_user), {
    ...user_info
  });
};

function* handleCreateNewUser(action: PayloadAction<IUserManagementData>) {
  yield put(showAppBackdrop());
  try {
    const response: IApiResponse<IUserData> = yield call(apiCreateNewUser, action.payload);
    if (response.data) {
      yield put(
        notify("Create new user success", { options: { variant: 'success' } })
      );
      yield call(handleFetchUsers);
      yield put(closeAppBackdrop());
    } else {
      if (response.detail !== '') {
        yield put(
          notify(`${response.detail}`, {
            options: { variant: 'error' },
          })
        );
      }
      yield put(closeAppBackdrop());
    }
  } catch (e) {
    yield put(closeAppBackdrop());
  }
}

export const apiDeleteAllHistory = async (username: string) => {
  return apiDelete<any>(formatPath(HistoryManagementPaths.delete_history_user), {
    username
  });
};

function* handleDeleteAllHistory(action: PayloadAction<string>) {
  yield put(showAppBackdrop());
  try {
    const response: IApiResponse<any> = yield call(apiDeleteAllHistory, action.payload);
    if (response.data) {
      yield put(
        notify(`${response.data.detail}`, {
          options: { variant: 'success' },
        })
      );
      yield put(closeAppBackdrop());
    } else {
      if (response.detail !== '') {
        yield put(
          notify(`${response.detail}`, {
            options: { variant: 'error' },
          })
        );
      }
      yield put(closeAppBackdrop());
    }
  } catch (e) {
    yield put(closeAppBackdrop());
  }
}


export const apiUpdateInfoMultiUser = (multi_user: any) => {
  return apiPost<any>(formatPath(UserManagementPaths.update_info_multi_user), multi_user);
};

function* handleUpdateInfoMultiUser(action: PayloadAction<any>) {
  yield put(showAppBackdrop());
  try {
    const response: IApiResponse<any> = yield call(apiUpdateInfoMultiUser, action.payload);
    if (response.data) {
      yield put(
        notify(response.data.detail, { options: { variant: 'success' } })
      );
      yield call(handleFetchUsers);
      yield put(closeAppBackdrop());
    } else {
      if (response.detail !== '') {
        yield put(
          notify(`${response.detail}`, {
            options: { variant: 'error' },
          })
        );
      }
      yield put(closeAppBackdrop());
    }
  } catch (e) {
    yield put(closeAppBackdrop());
  }
}

export default function* UserManagementSaga() {
  yield takeEvery(deleteUser.type, handleDeleteUser);
  yield takeEvery(fetchDataUser.type, handleFetchUsers);
  yield takeEvery(editUser.type, handleUpdateInfoUser);
  yield takeEvery(updateStatusUser.type, handleUpdateStatusUser);
  yield takeEvery(editUserLLM.type, handleUpdateUserLLM);
  yield takeEvery(editUserConfigure.type, handleUpdateUserConfigure);
  yield takeEvery(createNewUser.type, handleCreateNewUser);
  yield takeEvery(deleteAllHistory.type, handleDeleteAllHistory);
  yield takeEvery(fetchDataDepartment.type, handleFetchDataDepartment);
  yield takeEvery(updateInfoMultiUser.type, handleUpdateInfoMultiUser);
}
